import { __extends } from "tslib";
import { SelectObjectContentOutput, SelectObjectContentRequest } from "../models/index";
import { deserializeAws_restXmlSelectObjectContentCommand, serializeAws_restXmlSelectObjectContentCommand, } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { getSsecPlugin } from "@aws-sdk/middleware-ssec";
import { Command as $Command } from "@aws-sdk/smithy-client";
var SelectObjectContentCommand = /** @class */ (function (_super) {
    __extends(SelectObjectContentCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function SelectObjectContentCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    SelectObjectContentCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getSsecPlugin(configuration));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: SelectObjectContentRequest.filterSensitiveLog,
            outputFilterSensitiveLog: SelectObjectContentOutput.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    SelectObjectContentCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlSelectObjectContentCommand(input, context);
    };
    SelectObjectContentCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlSelectObjectContentCommand(output, context);
    };
    return SelectObjectContentCommand;
}($Command));
export { SelectObjectContentCommand };
//# sourceMappingURL=SelectObjectContentCommand.js.map